// helpers
import { getCartMenuItemPropertyForUpdate } from "./Cart";
// types
import {
    ApiMenuCartItem,
    CartItem,
    CombinedCartInStockItemRender,
    IGiftingInternalBusinessLine,
    GiftingCartItemType,
} from "@swiggy-private/cart-types";
// types
import { Item, CTAType } from "@swiggy-private/dls-web-recipe-common-web/dist/components/ReviewItemListCard";
import { STATIC_TEXTS } from "@cart-client/constants/GiftingCart";
// helpers
import { isValidNumber, isEmpty } from "@swiggy-private/core-ui";
import { slaTimerStringBuilder } from "@cart-client/helpers/GiftingCart";
import { isItemAvailable } from "@swiggy-private/cart-ui";

export const isFoodSubCart = (subCart: CombinedCartInStockItemRender) => {
    return subCart.businessLine === IGiftingInternalBusinessLine.FOOD;
};

export const isFoodItem = (subType?: GiftingCartItemType) => {
    return subType === GiftingCartItemType.FOOD;
};

export function getFoodCartItemsForUpdateCartAPI(foodCartItems?: CartItem[]): ApiMenuCartItem[] | undefined {
    const filteredItems: ApiMenuCartItem[] = [];
    if (foodCartItems && foodCartItems.length > 0) {
        foodCartItems.map((item) => {
            filteredItems.push(getCartMenuItemPropertyForUpdate(item));
        });
    }
    return filteredItems;
}

export const buildFoodItemToRenderProps = ({
    parentCartId,
    items,
    onItemAction,
    impressionCallback,
}: {
    parentCartId?: string;
    items?: CartItem[];
    onItemAction?: (item: Item, ctaType: CTAType) => void;
    impressionCallback?: (item: Item) => void;
}) => {
    if (isEmpty(items)) {
        return null;
    }
    const filteredFoodItems = items?.map((item) => {
        return {
            parentCartId,
            id: item?.id_hash || "",
            title: item?.name || "",
            subtitle: item?.description || "",
            imageId: item?.cloudinaryImageId || "",
            quantity: item?.quantity || 0,
            finalPrice: isValidNumber(item?.final_price) ? `₹${Math.round(item?.final_price / 100)}` : "",
            basePrice: isValidNumber(item?.subtotal) ? `₹${Math.round(item?.subtotal / 100)}` : "",
            ctaType: !isItemAvailable(item) ? CTAType.OOS : CTAType.QUANTITY_INC_DEC,
            ctaText: !isItemAvailable(item) ? STATIC_TEXTS.OOS : "",
            // TODO: Add logic to handle updating state
            updating: false,
            subType: GiftingCartItemType.FOOD,
            unavailableText: !isItemAvailable(item) ? STATIC_TEXTS.OOS : "",
            ctaClick: onItemAction,
            impressionEventCallback: impressionCallback,
        } as Item;
    });
    return {
        items: filteredFoodItems,
        restrictedQuantityItems: [],
    };
};

export const segregateFoodItemByShipment = ({
    isServiceable,
    slaTime,
    inStockFoodItems,
    disclaimer,
}: {
    isServiceable: boolean;
    slaTime: number;
    inStockFoodItems?: CartItem[] | null;
    disclaimer?: string;
}) => {
    if (isEmpty(inStockFoodItems)) {
        return null;
    }
    return {
        subCartId: `${IGiftingInternalBusinessLine.FOOD}_${Date.now()}`,
        isServiceable: isServiceable ?? false,
        slaTime: slaTime ?? 0,
        slaTimeString: slaTimerStringBuilder(slaTime ?? 0),
        items: inStockFoodItems,
        businessLine: IGiftingInternalBusinessLine.FOOD,
        disclaimer: disclaimer || "",
    };
};
